import { Action } from "redux";

export const WMS_3D_LAYER_LOADING = "WMS_3D_LAYER_LOADING";

export const wms3dLayerLoading = (): Action => {
    return {
        type: WMS_3D_LAYER_LOADING,
    };
};
